<template>
    <div><canvas ref="canvas"></canvas></div>
</template>

<script>
import Base from "./Base";
import weather from "../bl/weather";
export default {
    extends: Base,
    methods: {
        createData() {
            return {
                type: "line",
                data: {
                    labels: weather.moonPhases,
                    datasets: []
                },
                options: {}
            };
        },
        updateData(chart) {
            chart.data.datasets = [
                {
                    label: "# Catches",
                    borderColor: "rgb(0, 255, 174)",
                    backgroundColor: "rgba(0, 255, 174, 0.3)",
                    data: Array.from(weather.moonPhases.keys()).map(phase => this.dataSet(phase))
                }
            ];
        },
        dataSet(phase) {
            return this.$store.getters["catch/all"].filter(item => item.moonphase == phase).length;
        }
    }
};
</script>